import React from 'react';

type ActivityIndicatorProps = {}

export const ActivityIndicator: React.FunctionComponent<ActivityIndicatorProps> = () => {

    return (
        <div className="d-flex justify-content-center m-4 text-muted">
            <i className="fas fa-spinner fa-2x fa-spin"/>
        </div>
    );
};
